import { SliderSection } from './SharedNearbyFilterComponents'
import { NearbyFilterSlider } from './NearbyFilterSlider'

const renderValueRangeText = (props) => (
  // TODO: UPDATE THIS FOR ENOWMENT SIZE
  <>{parseFloat(props[0])?.toFixed(1) + '"' + ' - ' + parseFloat(props[1])?.toFixed(1) + '"'}</>
)

const EndowmentSizeSection = ({ value, onChange, resetValue, isDisplayedInactive }) => {
  const isInactive = isDisplayedInactive || (value?.[0] === 0 && value?.[1] === 13)
  return (
    <SliderSection>
      <NearbyFilterSlider
        name='endowmentSize'
        value={value}
        onValueChange={val => onChange('endowmentSize', val)}
        
        step={0.5}
        min={0}
        max={13}

        title='🍆 Size'
        resetValue={resetValue}
        isInactive={isInactive}
        renderValueRangeText={renderValueRangeText}
      />
    </SliderSection>
  )
}

export { EndowmentSizeSection }
